import { getStripe, getStripeCard, getToken } from '../../utils/stripe';
import { errorDescriptionFromResponse } from '../../utils/error';

export default function ModalEditPaymentController(
  Account,
  Checkout,
  $uibModal,
  $uibModalInstance,
  $http,
  $timeout,
  toaster,
  $rootScope,
  $cacheFactory,
  parentVM
) {
  'ngInject';

  this.cancel = () => $uibModalInstance.dismiss('cancel');

  this.$http = $http;
  this.$timeout = $timeout;
  this.$cacheFactory = $cacheFactory;
  this.$rootScope = $rootScope;
  this.toaster = toaster;
  this.account = $rootScope.account;
  this.Account = Account;

  this.states = [];
  this.$http.get('/img/states.json').then((response) => {
    this.states = response.data;
  });

  this.countries = [];
  this.$http.get('/img/countries.json').then((response) => {
    this.countries = response.data;
  });

  this.billing = angular.copy(parentVM.billing);
  this.cardOnFile = angular.copy(parentVM.cardOnFile);
  if (!this.billing.country || this.billing.country == '') {
    this.billing.country = 'US';
  }

  this.stripeCard = getStripeCard();

  this.checkPreviousSelectedPayment = () => {
    const paymentException =
      this.billing.payment_method === 'check' || this.billing.payment_method === 'po';
    if (Checkout.currentInterval(this.billing) === 'month' && paymentException) {
      this.showAllPaymentOptions = true;
    }
  };

  this.changePaymentMethod = () => {
    this.checkPreviousSelectedPayment();
    this.billing.payment_method = null;
    this.cardOnFile = null;
    this.newStripeToken = null;
    this.newStripePaymentMethod = null;
    this.changingPaymentMethod = true;
    if (Checkout.currentInterval(this.billing) === 'month') {
      this.selectedInterval = 'monthly';
    }
  };

  this.hasPaymentMethod = () => {
    return (
      this.billing.payment_method &&
      _.includes(['cc', 'ach', 'po', 'check'], this.billing.payment_method)
    );
  };

  if (!this.hasPaymentMethod()) {
    this.changePaymentMethod();
  }

  this.openStripe = () => {
    this.$http
      .post(`${API_ROOT}/stripe/create_setup_intent`, {
      })
      .then((response) => {
        return response.data.client_secret;
      })
      .catch((err) => {
        this.toaster.pop(
          'warning',
          'Unable to open Stripe: ' + err,
        );
      })
      .then((clientSecret) => {
        // Initialize Stripe Elements with the PaymentIntent's clientSecret,
        // then mount the payment element.
        const loader = 'auto';
        this.elements = getStripe().elements({ clientSecret, loader });
        const paymentElement = this.elements.create('payment');
        paymentElement.mount('#stripe-payment-element');
      });
  }

  this.retrieveStripePaymentMethod = (payment_method_id) => {
    return this.$http
      .post(`${API_ROOT}/stripe/retrieve_payment_method`, {
        payment_method_id: payment_method_id,
      })
      .then((response) => {
        return response.data.payment_method;
      });
  }

  this.addStripePaymentMethod = () => {
    this.addingStripePaymentMethod = true;
    getStripe()
      .confirmSetup({
        elements: this.elements,
        redirect: 'if_required',
      })
      .then(async (response) => {
        const payment_method = await this.retrieveStripePaymentMethod(response.setupIntent.payment_method)
        this.$timeout(() => {
          this.newStripePaymentMethod = response.setupIntent.payment_method;
          this.cardOnFile = {
            bank_name: payment_method.us_bank_account.bank_name,
            last4: payment_method.us_bank_account.last4,
          };
        });
      })
      .catch((err) => {
        this.$timeout(() => {
          this.toaster.pop('warning', 'Unable to process payment method: ' + err);
        });
      })
      .finally(() => {
        this.$timeout(() => {
          this.addingStripePaymentMethod = false;
        });
      });
  };

  this.addNewCard = () => {
    this.addingCard = true;
    getToken(this.stripeCard)
      .then((token) => {
        this.$timeout(() => {
          this.newStripeToken = token.id;
          this.cardOnFile = token.card;
        });
      })
      .catch((err) => {
        this.$timeout(() => {
          this.toaster.pop('warning', 'Unable to process credit card: ' + err);
        });
      })
      .finally(() => {
        this.addingCard = false;
      });
  };

  this.openPlaidLink = () => {
    _createLinkToken().then((linkToken) => {
      Plaid.create({
        token: linkToken,
        onSuccess: (public_token, metadata) => _onBankAccountLinkedViaPlaid(public_token, metadata),
      }).open();
    });
  };

  this.onSelectPaymentMethod = (m) => {
    this.billing.payment_method = m;
  };

  const _createLinkToken = () => {
    console.log('Creating Plaid link token');

    return this.$http
      .post(`${API_ROOT}/plaid/create_link_token`)
      .then((response) => {
        const linkToken = response.data.link_token;
        console.log('Plaid link_token', linkToken);
        return linkToken;
      })
      .catch((err) => {
        console.error('Error creating Plaid link token', err);
        this.toaster.pop('warning', 'We were unable to connect to our payment provider.');
      });
  };

  const _onBankAccountLinkedViaPlaid = (public_token, metadata) => {
    console.log('Plaid public_token', public_token);
    console.log('Plaid metadata', metadata);

    this.$http
      .post(`${API_ROOT}/plaid/exchange_token`, {
        public_token: public_token,
        plaid_account_id: metadata.account_id,
      })
      .then((response) => {
        this.billing.payment_method = 'ach';
        this.newStripeToken = response.data.stripe_bank_account_token;
        this.cardOnFile = null;
      })
      .catch((err) => {
        console.error('Error exchanging Plaid token', err);
        this.toaster.pop(
          'warning',
          'We were unable to associate your bank account with our payment provider.'
        );
        // XXX: TODO: save the public_token so that we can manually exchange/link
      });
  };

  this.update = () => {
    this.submitting = true;
    let updates = {
      address: this.billing.address,
      city: this.billing.city,
      country: this.billing.country,
      state: this.billing.state,
      email: this.billing.email,
      postal_code: this.billing.postal_code,
    };
    if (this.changingPaymentMethod) {
      updates.payment_method = this.billing.payment_method;
    }
    if (this.newStripeToken) {
      updates.stripe_token = this.newStripeToken;
    }
    this.Account.updateBilling(updates)
      .$promise.then(async () => {
        if (this.newStripePaymentMethod) {
          await this.$http
            .post(`${API_ROOT}/stripe/update_default_payment_method`, {
              payment_method_id: this.newStripePaymentMethod,
            })
        }
        this.account.refresh()
        .then(() => {
          this.$rootScope.$broadcast('account:updated');
        })
        .catch((err) => {
          console.error('Error refreshing account', err);
          this.toaster.pop('warning', 'Error refreshing account');
        })
        .finally(() => {
          this.cancel();
          parentVM.reload();
        });
      })
      .catch((err) => {
        console.log(err);
        let errorDetails = errorDescriptionFromResponse(err);
        this.toaster.pop('warning', 'Error updating payment settings', errorDetails);
      })
      .finally(() => {
        this.submitting = false;
      });
  };
}



// WEBPACK FOOTER //
// ./app/pages/settings/modal-edit-payment.js